import { makeValidated } from '../utils';
import interpolate from '../interpolate';
import schema from '../../schema/show-layout-component.schema.json';
import setLayoutProperty from './setLayoutProperty';

const mapShowLayoutComponent = action => ({
  type: 'setLayoutProperty',
  data: {
    path: `components.${action.data}.properties.visible`,
    value: true,
  },
});

const showLayoutComponent = (context, event, meta) => {
  const validated = makeValidated(schema);
  return setLayoutProperty(context, event, {
    action: mapShowLayoutComponent(
      validated(interpolate(meta.action, event, context))
    ),
  });
};

export default showLayoutComponent;
